import {
    CAREERPLAN_FETCHING,
    CAREERPLAN_SUCCESS,
    CAREERPLAN_FAILED,
  } from "../actions/types";

  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CAREERPLAN_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case CAREERPLAN_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case CAREERPLAN_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }